import * as React from "react";
import { Column } from "primereact/column";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "primereact/datatable";
import { getDate, filterDate, renderHeader, DropdownFilterElement } from "../../components/TableUtils";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import classNames from 'classnames';

export default function ServiceNotificationList({ opt, activeTenant }) {
    let dtable;
    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("notifichetagliandi", "attributes->'lastExecuted'", `tenant_id='${activeTenant._id}'`, "");

    const getHeader = () => {
        return (
            <Can
                roles={[roles.ADMIN, roles.CENTRALE]}
                yes={() => (
                    <div className="action-container">
                        <Link
                            title="Aggiungi Ticket"
                            className="btn btn-primary p-button-icon-only"
                            to={`/centrale/add-ticket`}
                        >
                            <i className="pi pi-plus mr-2"></i>Nuovo Richiamo
                        </Link>
                    </div>
                )}
                no={() => null}
            />
        );
    };

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title={`Elenco Richiami - Dealer: ${activeTenant.name}`}>
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, undefined, { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun richiamo in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Richiami su un totale di {totalRecords}"
                    >
                        <Column
                            field="attributes.name"
                            header="Cliente"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/service-notifications/${rowData._id}`}
                                    >
                                        {rowData.attributes.name}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="attributes.plate"
                            header="Targa"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.lastExecuted"
                            header="Data del richiamo precedente"
                            sortable
                            filter
                            body={getDate}
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.kmTot"
                            header="Km veicolo"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.modelKm"
                            header="Scadenza km"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.modelDuration"
                            header="Scadenza mesi"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="status"
                            header="Stato"
                            sortable
                            filter
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            filterElement={
                                <DropdownFilterElement
                                    field="status"
                                    options={[
                                        { label: "aperto", value: "aperto" },
                                        { label: "chiuso", value: "chiuso" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                                );
                            }}
                        />

                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Can
                                            roles={[roles.ADMIN, roles.DEALER, roles.SERVICE]}
                                            yes={() =>
                                                <Link
                                                    title="Gestisci richiamo"
                                                    className="btn btn-sm btn-primary p-button-icon-only"
                                                    to={`/tenant/service-notifications/${rowData._id}`}
                                                >
                                                    <FontAwesomeIcon icon="pencil-alt" />
                                                </Link>
                                            }
                                            no={() => null}
                                        />
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
        </PageLayout>
    );
}
